import { IoMdClose } from 'react-icons/io';
import { FiClock } from 'react-icons/fi';

interface LogEntry {
    timestamp: string;
    username: string;
    action: string;
}

interface Props {
    isOpen: boolean;
    logs: LogEntry[];
    loading?: boolean;
    onClose: () => void;
}

const formatLogDate = (isoDate: string): string => {
    try {
        const date = new Date(isoDate);
        return date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch {
        return isoDate;
    }
};

const OperationLogsDrawer = ({ isOpen, logs, loading = false, onClose }: Props) => {
    if (!isOpen) return null;

    const sortedLogs = [...logs].reverse();

    return (
        <div className="fixed inset-0 z-50 flex justify-end">
            <div className="absolute inset-0 bg-black/30" onClick={onClose} />
            <div className="relative w-full max-w-sm bg-white dark:bg-slate-800 h-full overflow-auto shadow-xl">
                <div className="sticky top-0 flex items-center justify-between p-4 border-b border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 z-10">
                    <div className="flex items-center gap-2">
                        <FiClock size={16} className="text-gray-500" />
                        <span className="text-sm font-semibold dark:text-white">Histórico de operações</span>
                    </div>
                    <button type="button" onClick={onClose} aria-label="Fechar histórico" className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                        <IoMdClose size={20} />
                    </button>
                </div>

                <div className="p-4">
                    {loading ? (
                        <div className="flex items-center justify-center py-8">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500" />
                        </div>
                    ) : sortedLogs.length === 0 ? (
                        <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">Nenhuma operação registrada</p>
                    ) : (
                        <div className="relative">
                            <div className="absolute left-3 top-2 bottom-2 w-px bg-gray-200 dark:bg-slate-700" />
                            <div className="space-y-4">
                                {sortedLogs.map((log, idx) => (
                                    <div key={idx} className="relative pl-8">
                                        <div className="absolute left-1.5 top-1.5 w-3 h-3 rounded-full bg-blue-500 border-2 border-white dark:border-slate-800" />
                                        <div className="bg-gray-50 dark:bg-slate-900 rounded-lg p-3 border border-gray-100 dark:border-slate-700">
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[11px] font-medium text-gray-700 dark:text-gray-300">{log.username}</span>
                                                <span className="text-[10px] text-gray-400">{formatLogDate(log.timestamp)}</span>
                                            </div>
                                            <p className="text-xs text-gray-600 dark:text-gray-400">{log.action.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OperationLogsDrawer;
